<template>
  <div :style="{ height: contentHeight + 'px', width: '100%' }">
    <iframe :src="src" frameborder="0"></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {
      src: '',
      contentHeight: document.documentElement.clientHeight,
    };
  },
  mounted() {
    console.log(this.$route);
    let data = this.$route.query;
    this.$axios.post('/api/transfer', data).then((res) => {
      console.log(res);
      if (res.data.code == 200) {
        this.src = res.data.data;
      }
    });
  },
};
</script>
<style scoped>
iframe {
  width: 99.7%;
  min-width: 980px;
  margin-top: -5px;
  height: 100%;
  display: block;
  height: calc(100% + 4px);
}
</style>



// WEBPACK FOOTER //
// src/view/user/transfer/index.vue